import gallop from "../../../../src/images/arthur-app-gallop.gif";
import soda from "../../../../src/images/arthur-app-soda.gif";
import shadows from "../../../../src/images/ngps-shadow-anim.gif";
import * as React from 'react';
export default {
  gallop,
  soda,
  shadows,
  React
};